import styled from "@emotion/styled";

export const PageWrapper = styled.div`
  overflow: hidden;
`;
